import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

const RefundPolicy = () => (
  <PolicyLayout
    title="Refund & Return Policy"
    kicker="Our Promise"
    intro="Due to the personal nature of jewelry products, we currently do not accept returns or exchanges unless the item received is damaged, defective, or incorrect."
    sections={[
      {
        heading: "Damaged or Incorrect Products",
        paragraphs: [
          "If you receive a damaged, defective, or wrong item, please contact us within 48 hours of delivery with:",
        ],
        bullets: ["Order Number", "Product Images", "Unboxing Video"],
      },
      {
        heading: "After Verification",
        paragraphs: ["We will provide a replacement or store credit once your claim has been reviewed."],
      },
      {
        heading: "Non-Returnable Items",
        bullets: [
          "Used products",
          "Products without original packaging",
          "Items damaged after delivery",
          "Change of mind purchases",
        ],
      },
      {
        heading: "Refunds",
        paragraphs: ["Approved refunds will be processed within 5–7 business days to the original payment method."],
      },
    ]}
  />
);

export default RefundPolicy;
